var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      {
        staticClass: "supsis-button",
        class:
          ((_obj = {}),
          (_obj[_vm.classNames] = true),
          (_obj.disabled = _vm.disabled),
          (_obj.primary = _vm.primary),
          (_obj.danger = _vm.danger),
          (_obj.warning = _vm.warning),
          (_obj.ghost = _vm.ghost),
          (_obj.small = _vm.small),
          (_obj.xsmall = _vm.xsmall),
          (_obj.xxsmall = _vm.xxsmall),
          (_obj.large = _vm.large),
          (_obj.xlarge = _vm.xlarge),
          (_obj.block = _vm.block),
          (_obj.icon = _vm.icon),
          (_obj.square = _vm.square),
          (_obj["has-floating-label"] = _vm.floatingLabel),
          (_obj.focused = _vm.focused),
          (_obj.filled = _vm.filled),
          _obj),
        attrs: { id: _vm.id },
        on: { click: _vm.click },
      },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _vm.floatingLabel
        ? _c("label", { staticClass: "floating-label" }, [
            _vm._v(_vm._s(_vm.floatingLabel)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.icon
        ? _c("i", { staticClass: "material-icons" }, [_vm._v(_vm._s(_vm.icon))])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }